import { Api } from "./api"

export class ProcessApi extends Api {
  constructor() {
    super('sample_processes', [])
  }
}
